import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { Router } from '@angular/router'
import { DomSanitizer } from '@angular/platform-browser'
import { MdDialog, MdIconRegistry } from '@angular/material'

import { Subscription } from 'rxjs/Subscription'

import { AuthService } from '../../auth/auth.service'

import { User } from '../../users/shared/user.model'
import { UserService } from '../../users/shared/user.service'

import { DialogService } from '../../dialog/shared/dialog.service'

@Component({
  selector: 'cm-blocked-list',
  templateUrl: './blocked-list.component.html',
  styleUrls: ['./blocked-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockedListComponent implements OnInit, OnDestroy {

  public blockedUsers: User[]

  private subscription: Subscription

  constructor(private authService: AuthService,
    private userService: UserService,
    private dialogService: DialogService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private iconRegistry: MdIconRegistry,
    private domSanitizer: DomSanitizer) {

      iconRegistry.addSvgIcon(
        'no-users',
        domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/img/icon/ic_no_users.svg')
      )
    }

  ngOnInit() {
    const uid = this.authService.currentUser.uid
    this.subscription = this.userService.getBlockedUsers(uid)
      .subscribe((users: User[]) => {
        this.blockedUsers = users
        // this.blockedUsers = []
        this.cd.markForCheck()
      })
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  unblocked(user: User) {
    this.dialogService
      .confirm('Débloquer l\'utilisateur', `Êtes-vous sur de vouloir débloquer l'utilisateur ${user.firstname} ?`)
      .subscribe((result: boolean) => {
        if (result === true) {
          this.userService.unblockUser(this.authService.currentUser.uid, user.uid)
        }
      })
  }

  gotoProfile(user: User) {
    this.router.navigate(['profile', user.uid])
  }

  trackByFn(index, item) {
    console.log(item.uid);

    return item.uid
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/blocked-list/blocked-list.component.ts